import { useEffect } from 'preact/hooks';

import { useAppActions } from '@/shared/stores/app-store/app-store';

import { useScreenOrientation } from './use-screen-orientation';

export const useScreenOrientationUpdater = () => {
  const { setScreenOrientation } = useAppActions();
  const orientation = useScreenOrientation();

  useEffect(() => {
    setScreenOrientation(orientation);
  }, [orientation, setScreenOrientation]);
};
